import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M8.7 5.698a.7.7 0 1 0-1.4 0v5.025l-.912-.607a.7.7 0 0 0-.776 1.165l2 1.333a.7.7 0 0 0 .776 0l2-1.333a.7.7 0 0 0-.776-1.165l-.912.607V5.698Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.502 15.142c.166.019.333.019.5.019.168 0 .318-.009.476-.018h.024c1.918-.158 3.557-1.298 4.382-3.058.852-1.825.676-3.881-.454-5.493L9.086 1.395c-.473-.74-1.705-.74-2.168 0L3.574 6.583c-1.14 1.63-1.306 3.687-.454 5.502.825 1.76 2.464 2.9 4.382 3.057Zm-2.76-7.79 3.26-5.068 3.27 5.086a4.089 4.089 0 0 1 .343 4.122c-.612 1.306-1.816 2.15-3.233 2.26-.25.02-.51.02-.77 0-1.407-.11-2.62-.954-3.232-2.26a4.067 4.067 0 0 1 .343-4.122c.009 0 .018-.018.018-.018Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  l,
  n
];
function r(a, s) {
  return t(), o("svg", c, [...d]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
